import { useStoreDollHouseMap } from "../../store";
import { useEffect, useState } from "react";
import {
  animationStart,
  animationEnd,
  showPopupWithContent,
  hidePopup,
} from "../../components/customEvents.js";
import { shallow } from "zustand/shallow";

export default function BellagioHotspot({ hoverContent }) {
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      sourcePoidSelected: state.sourcePoidSelected,
      destinationPoidSelected: state.destinationPoidSelected,
      BellagioHighlightPoiStore: state.BellagioHighlightPoiStore,
      resetBellagioHighlightPOI: state.resetBellagioHighlightPOI,
    }),
    shallow
  );
  const [destinationPoidSelected, setdestconventionActive] = useState("");
  const [sourceconventionActive, setsourceconventionActive] = useState("");

  const [restaurentActive, setrestaurentActive] = useState("");
  const [conventionActive, setconventionActive] = useState("");

  /*
   *BELLAGIO EXIST Route POI HIGHLIGHTING [start]
   */
  // useEffect(() => {
  //   if (dollhouseStore.sourcePoidSelected === "") {
  //     setsourceconventionActive("");
  //   }

  //   if (dollhouseStore.sourcePoidSelected === "bellagio_convention") {
  //     setsourceconventionActive("active-poi-selection");
  //   }
  // }, [dollhouseStore.sourcePoidSelected]);

  // useEffect(() => {
  //   if (dollhouseStore.destinationPoidSelected === "") {
  //     setdestconventionActive("");
  //   }

  //   if (dollhouseStore.destinationPoidSelected === "bellagio_convention") {
  //     setdestconventionActive("active-poi-selection");
  //   }
  // }, [dollhouseStore.destinationPoidSelected]);
  /*
   *BELLAGIO EXIST Route POI HIGHLIGHTING [end]
   */

  /*
   *BELLAGIO NOT EXIST Route POI HIGHLIGHTING [start]
   */

  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    setrestaurentActive("");
    setconventionActive("");

    if (dollhouseStore.BellagioHighlightPoiStore === "bellagio_restaurent") {
      setrestaurentActive("active-poi");
    } else if (
      dollhouseStore.BellagioHighlightPoiStore === "bellagio_convention"
    ) {
      setconventionActive("active-poi");
    } else {
      if (document.getElementById(dollhouseStore.BellagioHighlightPoiStore)) {
        document
          .getElementById(dollhouseStore.BellagioHighlightPoiStore)
          .classList.add("active-poi");
      }
    }
  }, [dollhouseStore.BellagioHighlightPoiStore]);

  /*
   *BELLAGIO NOT EXIST Route POI HIGHLIGHTING [end]
   */
  return (
    <>
      <g id="Bellagio" transform="translate(3910.294 976.918)">
        <g
          className="poi-hover"
          id="bellagio_tram_point"
          transform="translate(99.04 576.408)"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_tram_point");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_tram_point");
            showPopupWithContent(e, "bellagio_tram_point");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_tram_point");
            hidePopup("bellagio_tram_point");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_tram_point");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
        >
          <path d="M.46-.007,83.73,0l.018,109.56L.465,109.533Z" />
        </g>

        {/* <path
          d="M-1267.547-10942.139l82.447-1.634.759,137.206,9.244,41.669-9.244,9.688v55.727h-77.687v-2.124l-6.434-1.612v-6.937l3.584,1.3h2.85l-.225-21.931-6.425-1.569v-13.372l3.82,1.354h2.41l.2-26.812,4.476-8.407,2.552-6.847,1.607-10.046.483-8.668v-10l-.955-10.576-2.554-8.883-4.335-7.836v-5.867l.833-10.936-.213-54.794h-7.631Z"
          transform="translate(2022.127 12036.496)"
          className="poi-hover"
          id="bellagio_hotel_check_in"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_hotel_check_in");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_hotel_check_in");
            showPopupWithContent(e, "bellagio_hotel_check_in");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_hotel_check_in");
            hidePopup("bellagio_hotel_check_in");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_hotel_check_in");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          fill="rgba(255,255,255,0)"
        /> */}

        <path
          className="poi-hover"
          id="bellagio_hotel_check_in"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_hotel_check_in");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_hotel_check_in");
            showPopupWithContent(e, "bellagio_hotel_check_in");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_hotel_check_in");
            hidePopup("bellagio_hotel_check_in");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_hotel_check_in");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          fill="rgba(255,255,255,0)"
          d="M-1267.547-10942.139l82.447-1.634.759,137.206,9.244,41.669-9.244,9.688v55.727l2.71,44.19h9.071v187.568l-23.674,26.108-37.226,2.545-27.519-15.6-1.05-99.564v-7.068l-9.1-3.994v-51.774h10.983l-1.883-82.412v-2.124l-6.434-1.612v-6.937l3.584,1.3h2.85l-.225-21.931-6.425-1.569v-13.372l3.82,1.354h2.41l-2.41-18.528h-18.37l-44.644-1.991V-10848l8.641-2.094v-14.271h29.457v1.8h3.862v-51.484h17.922Z"
          transform="translate(2022.127 12036.496)"
        />

        <g
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_guest_elevator");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_guest_elevator");
            showPopupWithContent(e, "bellagio_guest_elevator");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_guest_elevator");
            hidePopup("bellagio_guest_elevator");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_guest_elevator");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          fill="rgba(255,255,255,0.01)"
          className="poi-hover"
          id="bellagio_guest_elevator"
        >
          <path
            id="bellagio-guest-elevator"
            d="M-364.656-11168.846l50.894.235,1.022,2.48h44.519l-.535,61.025h-3.277v41.574h-92.622Z"
            transform="translate(1657.574 12127.259)"
          />
          <g
            id="bellagio-spa-tower-entry"
            transform="translate(311.707 611.082)"
          >
            <rect width="88" height="47" stroke="none" />
            <rect x="2.5" y="2.5" width="83" height="42" fill="none" />
          </g>
          <path
            id="vip_lounge"
            data-name="vip lounge"
            d="M966.716,1161.318l57.558-25.177-43.827-96.485H969s-43.846,42.8-44.021,43.5a32.621,32.621,0,0,1-1.763,3.524l10.381.872Z"
          />
        </g>

        <g
          className="poi-hover"
          id="bellagio_fountains"
          transform="translate(1116.707 1781.082)"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_fountains");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_fountains");
            showPopupWithContent(e, "bellagio_fountains");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_fountains");
            hidePopup("bellagio_fountains");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_fountains");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
        >
          <path
            d="M149.5,0A149.5,149.5,0,1,1,0,149.5,149.5,149.5,0,0,1,149.5,0Z"
            stroke="none"
          />
          <path d="M 149.5 5 C 139.6925811767578 5 129.8928375244141 5.987762451171875 120.3729095458984 7.935791015625 C 111.0975036621094 9.833831787109375 101.9739227294922 12.66595458984375 93.25563049316406 16.35345458984375 C 84.69450378417969 19.97454833984375 76.43687438964844 24.4566650390625 68.71217346191406 29.67538452148438 C 61.05958557128906 34.84536743164062 53.86325073242188 40.78292846679688 47.32308959960938 47.32308959960938 C 40.78292846679688 53.86325073242188 34.84536743164062 61.05958557128906 29.67538452148438 68.71217346191406 C 24.4566650390625 76.43687438964844 19.97454833984375 84.69450378417969 16.35345458984375 93.25563049316406 C 12.66595458984375 101.9739227294922 9.833831787109375 111.0975036621094 7.935791015625 120.3729095458984 C 5.987762451171875 129.8928375244141 5 139.6925811767578 5 149.5 C 5 159.3074188232422 5.987762451171875 169.1071624755859 7.935791015625 178.6270751953125 C 9.833831787109375 187.9024963378906 12.66595458984375 197.0260925292969 16.35345458984375 205.744384765625 C 19.97454833984375 214.3054962158203 24.4566650390625 222.5631256103516 29.67538452148438 230.287841796875 C 34.84536743164062 237.9404144287109 40.78292846679688 245.1367492675781 47.32308959960938 251.6769104003906 C 53.86325073242188 258.2170715332031 61.05958557128906 264.1546325683594 68.71217346191406 269.3246154785156 C 76.43687438964844 274.5433349609375 84.69450378417969 279.0254516601562 93.25563049316406 282.6465454101562 C 101.9739227294922 286.3340454101562 111.0975036621094 289.1661682128906 120.3729095458984 291.064208984375 C 129.8928375244141 293.0122375488281 139.6925811767578 294 149.5 294 C 159.3074188232422 294 169.1071624755859 293.0122375488281 178.6270751953125 291.064208984375 C 187.9024963378906 289.1661682128906 197.0260925292969 286.3340454101562 205.744384765625 282.6465454101562 C 214.3054962158203 279.0254516601562 222.5631256103516 274.5433349609375 230.287841796875 269.3246154785156 C 237.9404144287109 264.1546325683594 245.1367492675781 258.2170715332031 251.6769104003906 251.6769104003906 C 258.2170715332031 245.1367492675781 264.1546325683594 237.9404144287109 269.3246154785156 230.287841796875 C 274.5433349609375 222.5631256103516 279.0254516601562 214.3054962158203 282.6465454101562 205.744384765625 C 286.3340454101562 197.0260925292969 289.1661682128906 187.9024963378906 291.064208984375 178.6270751953125 C 293.0122375488281 169.1071624755859 294 159.3074188232422 294 149.5 C 294 139.6925811767578 293.0122375488281 129.8928375244141 291.064208984375 120.3729095458984 C 289.1661682128906 111.0975036621094 286.3340454101562 101.9739227294922 282.6465454101562 93.25563049316406 C 279.0254516601562 84.69450378417969 274.5433349609375 76.43687438964844 269.3246154785156 68.71217346191406 C 264.1546325683594 61.05958557128906 258.2170715332031 53.86325073242188 251.6769104003906 47.32308959960938 C 245.1367492675781 40.78292846679688 237.9404144287109 34.84536743164062 230.287841796875 29.67538452148438 C 222.5631256103516 24.4566650390625 214.3054962158203 19.97454833984375 205.744384765625 16.35345458984375 C 197.0260925292969 12.66595458984375 187.9024963378906 9.833831787109375 178.6270751953125 7.935791015625 C 169.1071624755859 5.987762451171875 159.3074188232422 5 149.5 5 M 149.5 0 C 232.0665435791016 0 299 66.93345642089844 299 149.5 C 299 232.0665435791016 232.0665435791016 299 149.5 299 C 66.93345642089844 299 0 232.0665435791016 0 149.5 C 0 66.93345642089844 66.93345642089844 0 149.5 0 Z" />
        </g>

        {/* <g
          className="poi-hover"
          id="bellagio_fountains"
          transform="translate(1116.707 1781.082)"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_fountains");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_fountains");
            showPopupWithContent(e, "bellagio_fountains");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_fountains");
            hidePopup("bellagio_fountains");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
        >
          <circle cx="149.5" cy="149.5" r="149.5" stroke="none" />
          <circle cx="149.5" cy="149.5" r="147" fill="none" />
        </g> */}

        {/* 
      <g
        className="poi-hover"
        id="bellagio_fountains"
        transform="translate(8424 4622)"
        fill="rgba(255,255,255,0)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "bellagio_fountains");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("bellagio_fountains");
          showPopupWithContent(e, "bellagio_fountains");
        }}
        onMouseLeave={(e) => {
          animationEnd("bellagio_fountains");
          hidePopup("bellagio_fountains");
          dollhouseStore.resetBellagioHighlightPOI();
        }}
      >
        <circle cx="250" cy="250" r="250" />
        <circle cx="250" cy="250" r="247.5" />
      </g> */}

        <path
          d="M5908.722,13940.28H5753.085l-8.515-10.059-14.6-8.519v-47.294h6.168l5-4.643,1.777-6.153v-6.35l-.941-4.482-3.747-4.478-5-.941h-7.109v-23.937h-50.529v-68.333h-53.251v68.333h-42.843l2.568-13.683-1.088-7.714-3.247-5.14-4.334-4.618-4.185-2.834-8.82-2.574-10.013,1.49-7.315,2.693-10.023,9.758h-60.948l-21.66-25.665v-26.474l6.154-2.922,3.782-3.663,1.76-2.98,1.49-2.158,2.711-4.741v-14.627l-.822-3.114-1.89-3.246-4.873-5.29-5.29-1.893-4.317-1.49v-46.717h4.317v-30.465l-.09-2.792h-29.032v7.571H5173.7v-56.526h10.541v-16.842l7.771-12.382,1.9-7.889v-10.311l-1.9-6.836-3.964-7.83-4.895-5.65v-13.6l-7.623-.815v-54.069h9.631l194.289.234v6.087l.633,7.757,1.945,11.531,4.363,11.748,8.519,17.951,10.184,13.913,22.1-18.363,10.233,3.19h11.712l-.017-.511,6.92-.567,5.766-3.043,3.289-3.041,2.645-2.732,2.159-3.365,2-3.2,1.868-3.323,1.763-3.933.882-2.883,1.288-4,.476-3.212v-21.83l115.253.434h11.636v18.157h23.983v19.487h46.853v-20.648h26.295v-18.144h27.8l88.46,1.147v145.229h92.971v-146.376h167.675v36.06h34.422v7.745h-17.787v35.993h15.87v185.745l-3.068,80.813-93.478-3.236v133.967h-18.983l-25.33,28.11Z"
          transform="translate(-4847.968 -13044.688)"
          fill="rgba(255,255,255,0.05)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_pool");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_pool");
            showPopupWithContent(e, "bellagio_pool");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_pool");
            hidePopup("bellagio_pool");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_pool");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          className="poi-hover"
          id="bellagio_pool"
        />

        <path
          className="poi-hover"
          id="bellagio_spa"
          d="M-1475.9-11342.952v79.01h35.032v116.931H-1473.4v38.817h-84v-112.076h25.673v-122.682Z"
          transform="translate(2138.556 12197.469)"
          fill="rgba(255,255,255,0.01)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_spa");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_spa");
            showPopupWithContent(e, "bellagio_spa");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_spa");
            hidePopup("bellagio_spa");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_spa");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
        />
        {/* 
        <g
          className="poi-hover"
          id="bellagio_spa_tower_entrance"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_spa_tower_entrance");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_spa_tower_entrance");
            showPopupWithContent(e, "bellagio_spa_tower_entrance");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_spa_tower_entrance");
            hidePopup("bellagio_spa_tower_entrance");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_spa_tower_entrance");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          transform="translate(311.707 611.082)"
          fill="rgba(255,255,255,0.09)"
        >
          <rect width="88" height="47" stroke="none" />
          <rect x="2.5" y="2.5" width="83" height="42" fill="none" />
        </g> */}

        {/* <g
          className="poi-hover"
          id="bellagio_entrance_point_vdara"
          transform="translate(-0.293 572.082)"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_entrance_point_vdara");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_entrance_point_vdara");
            showPopupWithContent(e, "bellagio_entrance_point_vdara");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_entrance_point_vdara");
            hidePopup("bellagio_entrance_point_vdara");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_entrance_point_vdara");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
        >
          <rect width="97" height="25" stroke="none" />
          <rect x="2.5" y="2.5" width="92" height="20" fill="none" />
        </g> */}

        <path
          className="poi-hover"
          id="bellagio_conservatory"
          d="M-1298.046-11260.41l19.614-13.1,95.057-.288,16.695,9.147,1.066,181.173-132.943,1.271Z"
          transform="translate(2034.176 12169.582)"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_conservatory");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_conservatory");
            showPopupWithContent(e, "bellagio_conservatory");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_conservatory");
            hidePopup("bellagio_conservatory");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_conservatory");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
        />

        <path
          className="poi-hover"
          id="bellagio_dolby_theatre"
          d="M64.2-11750.359H347.615V-11456H232.925v12.663l-17.235,26.772v37.051l-11.682,53.62-59.778-25.557,3.926-10.639v-92.8l-84.523.46Z"
          transform="translate(1484.864 12361.759)"
          fill="rgba(255,255,255,0.02)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_dolby_theatre");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_dolby_theatre");
            showPopupWithContent(e, "bellagio_dolby_theatre");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_dolby_theatre");
            hidePopup("bellagio_dolby_theatre");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_dolby_theatre");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
        />

        <g
          onTouchStart={(e) => {
            // console.log("touch started");
            showPopupWithContent(e, "bellagio_convention");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_convention");
            showPopupWithContent(e, "bellagio_convention");
            setconventionActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_convention");
            hidePopup("bellagio_convention");
            setconventionActive("");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            // console.log("touch ended");
            hidePopup("bellagio_convention");
            setconventionActive("");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          className={`poi-hover ${conventionActive} `}
          id="bellagio_convention"
          fill="rgba(255,255,255,0)"
          transform="translate(20.65 2.923)"
        >
          <path
            id="Path_2019"
            data-name="Path 2019"
            d="M-2452.111-13633.45l8.317-2.284h57.449l.033,69.546h7.905v85.543l-8.614,2.769h-65.032Z"
            transform="translate(3505.103 13703.935)"
          />
          <path
            id="Path_2011"
            data-name="Path 2011"
            d="M-4216.557-13644.937l14.256-15.278,257.982.1v293.318h-253.16v-39.989h-19.2Z"
            transform="translate(4216.674 13713.806)"
          />
          <path
            id="Path_2012"
            data-name="Path 2012"
            d="M-3711.776-13656.2h0l4.688-3.531,58.289-.447.4,46.526-5.371,3.648-5.927.164.01,116.875h-47.28l-4.659,1.978Z"
            transform="translate(4013.071 13713.792)"
          />
          <path
            id="Path_2014"
            data-name="Path 2014"
            d="M-4188.568-13106.1l4.394-2.758h86.81l.249,181.467-90.992,1.32Z"
            transform="translate(4205.34 13491.468)"
          />
          <path
            id="Path_2015"
            data-name="Path 2015"
            d="M-3912.126-13105.2l4.783-2.947h86.046v192.915h-90.748Z"
            transform="translate(4093.863 13490.063)"
          />
          <path
            id="Path_2016"
            data-name="Path 2016"
            d="M-3702.232-13171.392l4.667-2.927h79.72v.809h330.726v44.455l-112.532-.589-.338,12.765-.577,11.148-4.222,12.379-6.576,9.475-6.3,5.366-8.341,3.737-13.142,1.053-12.321-3.988-9.624-9.642-5.42-11.073-3.668-14.787-.594-16.433h-25.481l-2.569,1.724h-203.409Z"
            transform="translate(4009.222 13517.865)"
          />
          <path
            id="Path_2017"
            data-name="Path 2017"
            d="M-2893.68-13745.025l7.068-3.742h247.463v222.736l-8.8,3.591h-45.667v-2.821h-200.448Z"
            transform="translate(3683.324 13749.515)"
          />
          <path
            id="Path_2018"
            data-name="Path 2018"
            d="M-2439.7-13744.678l8.24-5.158h140.072v170.467H-2190v87.743h-109.76v-30.146h-66.437v-87.79l10.049-4.135v-71.9H-2439.7Z"
            transform="translate(3500.096 13749.945)"
          />
          <path
            id="Path_2020"
            data-name="Path 2020"
            d="M-2781.691-13313.517h268.748v128.3h-96.206v13.062h-11.041l-1.312,5.954-2.909,4.971-4.272,4.155-7.465,3.121h-8.14l-6.753-1.537-4.979-3.816-3.481-5.267-2.562-5.923h-11.858v-14.72h-100.4v-43.019h-7.369Z"
            transform="translate(3638.008 13573.998)"
          />
          <path
            id="Path_2021"
            data-name="Path 2021"
            d="M-2152.31-13021.019l9.6-1.772h84.732v28.011l-7.449,1.979h-86.886Z"
            transform="translate(3384.206 13456.761)"
          />
          <path
            id="Path_2091"
            data-name="Path 2091"
            d="M583.613-10713.759l65.524.649,7.416,1.238.183,108.855H583.688Z"
            transform="translate(1254.529 11940.819)"
          />

          <path
            id="Path_2013"
            data-name="Path 2013"
            d="M-3570.583-13746.187l5.461-3.834h368.79v305.272l-7.364,2.738h-366.978Z"
            transform="translate(3956.17 13750.021)"
          />
        </g>

        {/* <g
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_convention");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_convention");
            showPopupWithContent(e, "bellagio_convention");
            setconventionActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_convention");
            hidePopup("bellagio_convention");
            setconventionActive("");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          className={`poi-hover ${conventionActive}  `}
          id="bellagio_convention"
          fill="rgba(255,255,255,0)"
          transform="translate(20.65 2.923)"
        >
          <path
            id="Path_2013"
            data-name="Path 2013"
            d="M-3570.583-13746.187l5.461-3.834h368.79v305.272l-7.364,2.738h-366.978Z"
            transform="translate(3956.17 13750.021)"
          />
        </g> */}

        <g
          onTouchStart={(e) => {
            showPopupWithContent(e, "bellagio_restaurent_12");
            setrestaurentActive("active-poi");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("bellagio_restaurent_12");
            showPopupWithContent(e, "bellagio_restaurent_12");
            setrestaurentActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("bellagio_restaurent_12");
            hidePopup("bellagio_restaurent_12");
            setrestaurentActive("");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("bellagio_restaurent_12");
            setrestaurentActive("");
            dollhouseStore.resetBellagioHighlightPOI();
          }}
          fill="rgba(255,255,255,0.07)"
          className={`poi-hover ${restaurentActive}`}
          id="bellagio_restaurent_12"
          transform="translate(355.822 324.055)"
        >
          <path
            id="Path_2022"
            data-name="Path 2022"
            d="M-1792.57-12552.929l-.1-50.08,181.5.076v48.626l-8.3,6.734-3.011,3.011-2.952,7.843v10.207l1.193,4.7,2.851,4.164,5.483,4.487,4.954,2.316v13.634l-199.429-.218v-5.822h-27.629v-32.771h14.616v-16.906Z"
            transform="translate(1838.005 12888.771)"
          />

          <path
            id="Path_2023"
            data-name="Path 2023"
            d="M-1158.752-12335.855l.645-6.557,2.113-6.428,3.919-5.678,4.421-3.814,6-3.1,8.735-1.035,6.566.58,7.8,3.559,4.832,5.871,4.141,8.186,1.059,9.775h51.5v21.486h5.288l4.133,1.133,2.605,2.617,1.535,3.51.611,5.324-.611,6.756-2.5,4.334-4.968,2.352h-6.559v45.848l-28.731,20.8-72.529.135v-38.2h-44v-56.271H-1181v11.844h22.252Z"
            transform="translate(1581.835 12791.772)"
          />

          <path
            id="Path_2024"
            data-name="Path 2024"
            d="M-1323.62-12190.852h34.864v77.813h-34.864Z"
            transform="translate(1630.792 12722.339)"
          />

          <path
            id="Path_2027"
            data-name="Path 2027"
            d="M-823.873-12118.174h12.636v143.606h-88.769l.035-143.9h11.318l-.1,14.632h11.91l2.561,6.09,3.661,5.381,4.789,3.556,6.518,1.535h8.379l7.28-2.866,4.392-4.125,2.986-5.379,1.353-5.661h11.053Z"
            transform="translate(1517.636 12186.146)"
          />

          <path
            id="Path_2028"
            data-name="Path 2028"
            d="M11474.628-12138.525h8.15l10,11.755h153.184v64.842h-120.2l-4.813.629-3.755,1.514-2.31,1.688-2.882,3.069-1.289,3.331-.568,2.963v60.987h-24.573l-6.729,13.765h-23.7l-.747-148.468Z"
            transform="translate(-10942.745 12701.466)"
          />

          <path
            id="Path_2031"
            data-name="Path 2031"
            d="M11660.955-11909.2l88.365-36.855,10.527,50.8-22.049,5.147v52.83h-26.094v7.454h-15.859Z"
            transform="translate(-11026.043 12623.853)"
          />

          <path
            id="Path_2033"
            data-name="Path 2033"
            d="M310.311-10425.8l84.165-.228,12.386,19.481-17.6,43.933,4.968,10.839.034,41.6-61.732-.309v18.905H313.479l-4.034-1.037-2.81-1.935-2.374-2.377-2.376-2.364-1.782-2.739-1.341-4.479v-5.927l-12.646-3.943v-16.078l12.953,2.128v-30.483l-12.953-2.072v-18.479l12.235,2.445v-36.5Z"
            transform="translate(1039.324 11503.659)"
          />

          <path
            id="Path_2034"
            data-name="Path 2034"
            d="M-729.466-10296.287l34.562-.387h40.965v59.192h14.678v25.377H-653.94v41.17h6.649v68.983l-75.152.649-.022-69.633h8.189l.051-42.295h-14.9Z"
            transform="translate(1448.864 11451.495)"
          />

          <path
            id="Path_2035"
            data-name="Path 2035"
            d="M-493.346-10307.035h14.365v-8.216h99.773v6.171h11.576v84.958h5.935v36.234h-40.091v4.824l-12.688,2.7-1.988,3.4-1.581,1.84-1.387,1.015-1.468.5h-1.845l-1.434-.277-1.46-1.048-.959-1.192-.83-1.565-.941-2.678-13.723-2.7v-4.824l-41.121.273-.115-47.785-10.239-9.948Z"
            transform="translate(1353.736 11458.986)"
          />

          <path
            id="Path_2036"
            data-name="Path 2036"
            d="M-211.265-10299.313H-84.684l77.21,76.339H9.278l10-10.617.357,92.958,28.68,26.47-46.9,49.056-15.395-15.181,4.168-5.874-6.927-6.524-45.106-46.492h-127.83v-39.486h-21.14Z"
            transform="translate(1239.896 11452.56)"
          />

          <path
            id="Path_2037"
            data-name="Path 2037"
            d="M245.751-9843.653l5.757-36.545,56.27,114.239,18.86-11.534,7.635,94.479h41.639l-1.513,5.073-2.284,8.3v8.88l1.149,7.229,4.455,6.2,9.984,7.676,9.214,32.761H334.272l-8.045,7.51h-6.8l-8.834-20.431,4.111-3.991,4.161-7.386,2.355-9.165-2.355-11.1-4.161-6.62-6.3-4.767-7.46-1.119-9.87,2.2-13.632-26.481,10.468-5.216v-35.34l-16.484-.642L240.7-9788.937Z"
            transform="translate(1057.639 11283.549)"
          />

          <path
            id="Path_2038"
            data-name="Path 2038"
            d="M-568.857-11544.944h50.55v56.475h-50.55Z"
            transform="translate(1384.097 11954.868)"
          />

          <path
            id="Path_2039"
            data-name="Path 2039"
            d="M-417.483-11600.881l68.117.075-.044,65.474-67.886.361Z"
            transform="translate(1323.055 11977.425)"
          />

          <path
            id="Path_2040"
            data-name="Path 2040"
            d="M-139.993-11318.839l118.495.065v41.228l84.639.091-.016,87.979-4.694,13.28,3.216,3.533-29.975,85.943-100.387-49.565-26.392,52.093-.571,1.2-24.142-11.2,32.108-108.162-51.6-10.992Z"
            transform="translate(1211.155 11863.689)"
          />

          <path
            id="Path_2121"
            data-name="Path 2121"
            d="M1510.565,1871.76l10.992-2.661,2.532,12.18,7.115,4.7.966-.72,11.818,5.427,25.355,17.327v19.423h-9.906l-7.8-.5-9.847,1.783-22.906,5.709-2.268-8.173-12.662-44.981,8.08-3.377Z"
          />
        </g>
      </g>
    </>
  );
}
